import React from 'react';
export const PageErrorStateIcon = () => /*#__PURE__*/React.createElement("svg", {
  width: "615",
  height: "418",
  viewBox: "0 0 615 418",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  opacity: "0.7",
  clipPath: "url(#clip0_1751_86975)"
}, /*#__PURE__*/React.createElement("path", {
  opacity: "0.14",
  d: "M378.5 419C492.547 419 585 326.547 585 212.5C585 98.4532 492.547 6 378.5 6C264.453 6 172 98.4532 172 212.5C172 326.547 264.453 419 378.5 419Z",
  fill: "url(#paint0_radial_1751_86975)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: "0.4",
  d: "M283.5 384C384.292 384 466 302.292 466 201.5C466 100.708 384.292 19 283.5 19C182.708 19 101 100.708 101 201.5C101 302.292 182.708 384 283.5 384Z",
  fill: "url(#paint1_radial_1751_86975)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd_1751_86975)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M458.52 223.341L336.785 190.425C333.112 189.05 327.917 190.1 325.766 192.239L205.733 312.016C205.275 312.473 204.642 312.698 204.342 313.35C203.378 315.44 206.988 321.163 209.562 321.853L334.618 355.361C337.557 356.149 341.684 355.054 343.835 352.915L462.615 234.263C465.801 230.167 461.459 224.129 458.52 223.341Z",
  fill: "url(#paint2_linear_1751_86975)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M457.169 222.658L334.256 189.724C331.056 188.866 326.561 190.071 324.218 192.414L205.924 310.708C203.581 313.051 204.276 315.646 207.477 316.504L328.457 348.92C332.725 350.064 338.717 348.458 341.842 345.334L458.722 228.454C461.065 226.111 460.37 223.516 457.169 222.658Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_1751_86975)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M342.731 347.675L459.199 229.104C461.384 226.879 460.853 224.422 457.98 223.465L450.784 221.066L335.15 190.603C331.953 189.761 327.486 190.962 325.148 193.292L206.528 311.527C204.197 313.85 204.852 316.428 207.996 317.31L329.186 351.292C333.483 352.497 339.599 350.863 342.731 347.675Z",
  fill: "url(#paint3_linear_1751_86975)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M457.169 222.658L334.256 189.724C331.056 188.866 326.561 190.071 324.218 192.414L205.924 310.708C203.581 313.051 204.276 315.646 207.477 316.504L328.457 348.92C332.725 350.064 338.717 348.458 341.842 345.334L458.722 228.454C461.065 226.111 460.37 223.516 457.169 222.658Z",
  fill: "url(#paint4_linear_1751_86975)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M338.997 221.561C338.864 221.098 338.047 220.979 337.387 220.81L284.098 207.105C283.519 206.95 282.731 207.108 282.07 207.468C281.51 207.774 281.09 208.172 280.575 208.509L279.549 209.181C279.034 209.519 278.547 209.894 278.415 210.309C278.164 211.092 278.382 212.101 279.007 212.269L333.201 226.79C334.016 227.008 335.245 226.607 335.948 225.894L338.493 223.312C338.941 222.858 339.143 222.072 338.997 221.561Z",
  fill: "#4926CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M338.293 220.716L284.099 206.195C283.285 205.977 282.055 206.378 281.352 207.091L278.807 209.673C278.104 210.386 278.194 211.141 279.008 211.359L333.202 225.88C334.017 226.098 335.246 225.697 335.949 224.984L338.494 222.402C339.197 221.689 339.107 220.934 338.293 220.716Z",
  fill: "#6942F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M345.635 238.659C345.325 238.392 344.726 238.332 344.229 238.203L271.876 219.395C271.192 219.212 270.368 219.274 269.675 219.52C268.843 219.815 268.247 220.368 267.522 220.785L266.892 221.146C266.166 221.563 265.502 222.066 265.496 222.598C265.487 223.392 266.023 224.354 266.805 224.564L339.943 244.161C341.043 244.456 342.5 244.116 343.2 243.402L345.736 240.818C346.276 240.266 346.222 239.164 345.635 238.659Z",
  fill: "#4926CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M344.764 238.015L271.626 218.418C270.527 218.123 269.069 218.463 268.369 219.177L265.834 221.762C265.134 222.476 265.457 223.292 266.556 223.587L339.694 243.184C340.793 243.479 342.25 243.139 342.951 242.425L345.486 239.84C346.186 239.126 345.863 238.31 344.764 238.015Z",
  fill: "#6942F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M299.054 259.675C298.943 259.194 298.11 259.066 297.433 258.892L245.564 245.567C244.995 245.415 244.209 245.581 243.551 245.95C243.011 246.254 242.602 246.641 242.103 246.971L241.048 247.669C240.548 247.999 240.075 248.365 239.936 248.77C239.668 249.552 239.86 250.566 240.472 250.73L293.262 264.875C294.055 265.088 295.267 264.683 295.971 263.969L298.517 261.388C298.955 260.943 299.17 260.183 299.054 259.675Z",
  fill: "#4926CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M298.374 258.807L245.584 244.662C244.791 244.45 243.579 244.855 242.875 245.568L240.329 248.15C239.626 248.863 239.699 249.613 240.492 249.825L293.282 263.97C294.075 264.183 295.287 263.777 295.991 263.064L298.537 260.483C299.24 259.769 299.167 259.02 298.374 258.807Z",
  fill: "#6942F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M298.315 241.908C298.119 241.622 297.649 241.487 297.185 241.374L257.772 231.772C257.302 231.647 256.549 231.898 255.905 232.359C255.542 232.618 255.236 232.905 254.876 233.167L253.567 234.119C253.207 234.38 252.865 234.658 252.692 234.964C252.258 235.736 252.177 236.801 252.666 236.932L292.325 247.559C292.921 247.718 294.447 247.262 295.153 246.55L297.883 243.819C298.44 243.257 298.685 242.448 298.315 241.908Z",
  fill: "#4926CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M297.623 241.54L257.963 230.914C257.368 230.754 256.314 231.202 255.608 231.915L253.055 234.494C252.35 235.207 252.262 235.914 252.857 236.073L292.517 246.7C293.113 246.86 294.167 246.412 294.872 245.699L297.425 243.119C298.13 242.407 298.219 241.7 297.623 241.54Z",
  fill: "#6942F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M306.438 279.61C306.128 279.344 305.529 279.283 305.031 279.154L232.678 260.346C231.994 260.163 231.171 260.226 230.478 260.471C229.646 260.766 229.05 261.319 228.324 261.736L227.695 262.098C226.969 262.515 226.305 263.018 226.299 263.549C226.29 264.344 226.826 265.306 227.608 265.516L300.746 285.113C301.845 285.407 303.303 285.068 304.003 284.354L306.538 281.769C307.079 281.218 307.025 280.115 306.438 279.61Z",
  fill: "#4926CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M305.565 278.966L232.427 259.369C231.328 259.075 229.87 259.414 229.17 260.128L226.635 262.713C225.934 263.427 226.258 264.244 227.356 264.538L300.495 284.135C301.594 284.43 303.051 284.09 303.751 283.376L306.287 280.792C306.987 280.078 306.664 279.261 305.565 278.966Z",
  fill: "#6942F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M259.12 282.86C258.924 282.573 258.454 282.438 257.99 282.325L218.577 272.724C218.107 272.598 217.353 272.849 216.71 273.31C216.347 273.57 216.04 273.856 215.681 274.118L214.371 275.07C214.012 275.332 213.67 275.609 213.497 275.916C213.063 276.687 212.982 277.752 213.47 277.883L253.13 288.51C253.726 288.67 255.252 288.214 255.957 287.501L258.688 284.771C259.245 284.208 259.489 283.399 259.12 282.86Z",
  fill: "#4926CD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M258.427 282.492L218.768 271.865C218.172 271.706 217.118 272.153 216.413 272.866L213.86 275.446C213.155 276.158 213.066 276.865 213.662 277.025L253.321 287.651C253.917 287.811 254.971 287.363 255.677 286.651L258.23 284.071C258.935 283.358 259.023 282.652 258.427 282.492Z",
  fill: "#6942F8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M329.881 214.078L328.245 213.639L328.356 207.544L323.579 212.389L321.97 211.958L328.724 205.107L330.36 205.546L330.249 211.641L335.026 206.796L336.635 207.227L329.881 214.078ZM334.948 215.586C334.253 215.4 333.737 215.115 333.397 214.731C333.066 214.35 332.938 213.914 333.011 213.423C333.094 212.935 333.38 212.442 333.869 211.946C334.359 211.449 334.96 211.041 335.674 210.722C336.396 210.405 337.151 210.206 337.939 210.124C338.735 210.045 339.48 210.098 340.175 210.284C340.86 210.467 341.368 210.75 341.698 211.131C342.038 211.515 342.171 211.953 342.097 212.443C342.024 212.934 341.742 213.428 341.253 213.924C340.763 214.421 340.157 214.827 339.435 215.144C338.712 215.461 337.953 215.659 337.156 215.738C336.369 215.82 335.633 215.77 334.948 215.586ZM335.424 212.362C335.137 212.654 334.963 212.946 334.902 213.239C334.856 213.528 334.927 213.786 335.115 214.012C335.311 214.24 335.608 214.407 336.005 214.514C336.401 214.62 336.831 214.647 337.292 214.595C337.754 214.543 338.192 214.422 338.607 214.232C339.038 214.038 339.397 213.795 339.684 213.504C339.971 213.213 340.138 212.922 340.183 212.633C340.244 212.34 340.181 212.081 339.994 211.855C339.806 211.629 339.514 211.463 339.117 211.356C338.721 211.25 338.287 211.222 337.816 211.271C337.355 211.323 336.909 211.446 336.478 211.641C336.063 211.831 335.712 212.071 335.424 212.362ZM343.608 215.66C343.379 215.891 343.292 216.09 343.346 216.255C343.4 216.42 343.589 216.546 343.914 216.633C344.22 216.715 344.594 216.74 345.036 216.708L344.009 217.75C343.493 217.788 343.005 217.745 342.545 217.622C341.815 217.426 341.402 217.14 341.307 216.763C341.218 216.379 341.421 215.936 341.917 215.433L344.452 212.861L343.289 212.549L344.288 211.537L345.451 211.848L346.743 210.538L348.257 210.943L346.965 212.254L348.912 212.776L347.914 213.789L345.967 213.267L343.608 215.66ZM357.847 213.676C357.17 213.495 356.604 213.636 356.147 214.099L355.668 214.586L357.507 215.079L356.508 216.091L354.669 215.599L350.676 219.65L349.161 219.244L353.155 215.193L351.992 214.881L352.99 213.868L354.153 214.18L354.701 213.624C355.21 213.108 355.793 212.753 356.45 212.561C357.107 212.369 357.8 212.371 358.53 212.566C358.981 212.687 359.327 212.868 359.569 213.108L358.6 214.091C358.431 213.904 358.18 213.765 357.847 213.676ZM356.513 221.364C355.819 221.178 355.302 220.893 354.962 220.51C354.632 220.128 354.503 219.692 354.577 219.201C354.659 218.713 354.945 218.221 355.435 217.724C355.924 217.228 356.526 216.82 357.239 216.501C357.962 216.184 358.717 215.984 359.504 215.903C360.3 215.823 361.046 215.876 361.74 216.062C362.425 216.246 362.933 216.528 363.264 216.91C363.603 217.294 363.736 217.731 363.663 218.222C363.589 218.713 363.308 219.206 362.818 219.703C362.329 220.199 361.723 220.606 361 220.922C360.278 221.239 359.518 221.437 358.722 221.517C357.934 221.599 357.198 221.548 356.513 221.364ZM356.99 218.141C356.703 218.432 356.529 218.724 356.467 219.018C356.422 219.307 356.493 219.564 356.68 219.79C356.877 220.018 357.173 220.186 357.57 220.292C357.967 220.398 358.396 220.425 358.858 220.373C359.319 220.321 359.758 220.2 360.173 220.01C360.604 219.816 360.962 219.573 361.25 219.282C361.537 218.991 361.703 218.701 361.749 218.412C361.81 218.119 361.747 217.859 361.559 217.633C361.372 217.407 361.079 217.241 360.683 217.135C360.286 217.028 359.852 217 359.382 217.05C358.92 217.102 358.474 217.225 358.043 217.419C357.628 217.609 357.277 217.85 356.99 218.141ZM364.657 223.546C364.026 223.377 363.552 223.142 363.234 222.839C362.933 222.532 362.807 222.18 362.856 221.784C362.914 221.389 363.152 220.98 363.57 220.557L366.575 217.508L368.089 217.914L365.231 220.814C364.872 221.178 364.735 221.513 364.82 221.82C364.911 222.121 365.209 222.339 365.714 222.474C366.21 222.607 366.719 222.605 367.24 222.469C367.769 222.326 368.212 222.073 368.571 221.709L371.429 218.809L372.944 219.215L369.939 222.263C369.521 222.687 369.018 223.025 368.427 223.277C367.846 223.531 367.229 223.683 366.575 223.734C365.927 223.778 365.288 223.716 364.657 223.546ZM378.578 220.574C379.398 220.794 379.877 221.152 380.014 221.649C380.16 222.148 379.936 222.699 379.342 223.302L376.2 226.489L374.685 226.083L377.465 223.263C377.85 222.873 377.999 222.519 377.912 222.203C377.84 221.883 377.543 221.652 377.02 221.512C376.47 221.365 375.908 221.369 375.333 221.525C374.764 221.673 374.288 221.943 373.903 222.334L371.142 225.134L369.628 224.728L374.62 219.664L376.134 220.07L375.488 220.725C376.565 220.361 377.595 220.311 378.578 220.574ZM384.819 228.798L383.304 228.392L384.019 227.668C383.463 227.862 382.906 227.976 382.347 228.011C381.789 228.045 381.262 227.996 380.766 227.863C380.126 227.691 379.659 227.42 379.364 227.048C379.079 226.679 378.986 226.252 379.087 225.769C379.196 225.288 379.496 224.799 379.985 224.302C380.475 223.806 381.063 223.395 381.749 223.068C382.445 222.744 383.164 222.535 383.906 222.441C384.657 222.349 385.353 222.389 385.993 222.561C386.489 222.694 386.872 222.889 387.144 223.145C387.415 223.402 387.561 223.705 387.582 224.054L390.352 221.244L391.866 221.649L384.819 228.798ZM381.54 224.719C381.253 225.01 381.079 225.303 381.018 225.596C380.972 225.885 381.043 226.142 381.231 226.368C381.418 226.594 381.715 226.762 382.121 226.87C382.517 226.977 382.947 227.004 383.408 226.952C383.87 226.9 384.308 226.779 384.723 226.589C385.154 226.395 385.513 226.152 385.8 225.861C386.087 225.569 386.254 225.279 386.299 224.99C386.36 224.697 386.297 224.437 386.11 224.211C385.922 223.985 385.63 223.819 385.233 223.713C384.828 223.604 384.394 223.576 383.933 223.628C383.471 223.68 383.025 223.803 382.594 223.997C382.179 224.187 381.828 224.428 381.54 224.719Z",
  fill: "#282863"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd_1751_86975",
  x: "184.182",
  y: "159.806",
  width: "299.551",
  height: "223.811",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "-10"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "10"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1751_86975"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "8"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "10"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.21 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_1751_86975",
  result: "effect2_dropShadow_1751_86975"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_1751_86975",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_1751_86975",
  x: "204.133",
  y: "189.334",
  width: "257.41",
  height: "163.354",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "0.5",
  result: "effect1_foregroundBlur_1751_86975"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial_1751_86975",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(378.5 212.5) scale(206.5)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF8FE6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#FF8FE6",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_1751_86975",
  cx: "0",
  cy: "0",
  r: "1",
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(283.5 201.5) scale(182.5)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8296FF",
  stopOpacity: "0.6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#8296FF",
  stopOpacity: "0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1751_86975",
  x1: "465.33",
  y1: "219.832",
  x2: "191.251",
  y2: "152.605",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8B98DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.200284",
  stopColor: "#C1CBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.303741",
  stopColor: "#E9ECFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.310958",
  stopColor: "#DDE2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.333069",
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.491969",
  stopColor: "#CED6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.857402",
  stopColor: "#94A0E3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#DAE0FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_1751_86975",
  x1: "463.981",
  y1: "213.33",
  x2: "-53.2373",
  y2: "882.82",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_1751_86975",
  x1: "463.07",
  y1: "212.42",
  x2: "-54.1486",
  y2: "881.91",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1751_86975"
}, /*#__PURE__*/React.createElement("rect", {
  width: "615",
  height: "418",
  fill: "white"
}))));